import { FC } from 'react';
import styles from './Card.module.scss';
import { generateImageUrl } from '../../../../../helpers/generateImageUrl';
import { ImageResponseType } from '../../../../../types/base';
import { localizeDate } from '../../../../../helpers/formatters';

export interface ICard {
  title: string;
  date: string;
  annotation: string;
  image: ImageResponseType;
}

const Card: FC<ICard> = ({ title, date, annotation, image }) => {
  return (
    <div className={styles.Card}>
      <img
        src={
          image?.s3Key
            ? generateImageUrl(image?.s3Key)
            : '/images/placeholderImage.png'
        }
        className={styles.img}
      />
      <div className={styles.content}>
        <span>{localizeDate(date)}</span>
        <h2>{title}</h2>
        <p>{annotation}</p>
      </div>
    </div>
  );
};

export default Card;
